// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MetricsWebFooter_wrap__2ibUl","container":"MetricsWebFooter_container__2g3lQ","col":"MetricsWebFooter_col__1PJux"};